import { DataRow, isDataRow, ModelChildLoader, Row } from '@paragon/layout-models';
import { forceArray } from '@paragon/utilities';

import { getFirstDataRowParent } from '../util/getFirstDataRowParent';

const ROWS_WITH_IDENTIFIER = new Set(['manualLoad', 'parapetLoad', 'movingLoad', 'jackComponent']);

// Added to fulfill this spec:
// https://trello.com/c/oKL7ZA83/5825-3-categorize-and-delete-manually-inserted-loads#comment-5d543e5183121e8fa1d22d63
export function addIdentifierToDataRowName(currentRowName: string, row: Row, loader: ModelChildLoader) {
  if (!isDataRow(row) || !row.parent || !ROWS_WITH_IDENTIFIER.has(row.type)) {
    return currentRowName;
  }

  const parent = getFirstDataRowParent(row);
  if (parent === null) {
    throw new Error(`Could not find data row parent for ${row.id}`);
  }

  const rowItem = row.item as { guid: string; type: string };
  const allChildren = forceArray(loader.getChildrenOf(parent.item, row.schema));
  const childrenWithSameName = allChildren.filter((child) => currentRowName === new DataRow(child, row.schema).name);

  if (Array.isArray(childrenWithSameName) && childrenWithSameName.length > 1) {
    const position = childrenWithSameName.findIndex((child) => (child as { guid?: string }).guid === rowItem.guid);
    if (position >= 1) {
      return `${currentRowName} (${position})`;
    }
  }

  return currentRowName;
}
